export default __webpack_public_path__ + "static/media/blockchains.73458918.svg";